import { Form as InertiaForm } from '@inertiajs/react'
import { type ComponentProps, useEffect, useState } from 'react'

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import { AreaType } from './types'
import {Textarea} from "@/components/ui/textarea.tsx";

interface CommunityOption {
  id: string
  name: string
}

type FormProps = Omit<ComponentProps<typeof InertiaForm>, 'children'> & {
  area: AreaType
  submitText: string
  communities?: CommunityOption[]
}

const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
] as const

export default function Form({
  area,
  submitText,
  communities = [],
  ...formProps
}: FormProps) {
  const initialStatus = area.status || 'active'
  const initialCommunityId = area.community_id || communities[0]?.id || ''
  const [status, setStatus] = useState(initialStatus)
  // const [communityId, setCommunityId] = useState(initialCommunityId)

  useEffect(() => {
    setStatus(initialStatus)
    // setCommunityId(initialCommunityId)
  }, [initialStatus, initialCommunityId])

  return (
    <InertiaForm
      transform={data => ({ area: data })}
      className="contents"
      {...formProps}
    >
      {({ errors, processing }) => (
        <>
          <div className="my-2">
            <Label htmlFor="name">Name</Label>
            <Input
              type="text"
              name="name"
              id="name"
              defaultValue={area.name}
            />
            {errors.name && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.name.join(', ')}
              </div>
            )}
          </div>

          {/*<div className="my-5">*/}
          {/*  <Label htmlFor="community_id">Community</Label>*/}
          {/*  <input type="hidden" name="community_id" value={communityId} />*/}
          {/*  <Select value={communityId} onValueChange={setCommunityId}>*/}
          {/*    <SelectTrigger id="community_id">*/}
          {/*      <SelectValue placeholder="Select community" />*/}
          {/*    </SelectTrigger>*/}
          {/*    <SelectContent>*/}
          {/*      {communities.map((community) => (*/}
          {/*        <SelectItem key={community.id} value={community.id}>*/}
          {/*          {community.name}*/}
          {/*        </SelectItem>*/}
          {/*      ))}*/}
          {/*    </SelectContent>*/}
          {/*  </Select>*/}
          {/*  {errors.community_id && (*/}
          {/*    <div className="text-red-500 px-3 py-2 font-medium">*/}
          {/*      {errors.community_id.join(', ')}*/}
          {/*    </div>*/}
          {/*  )}*/}
          {/*</div>*/}

          <div className="my-2">
            <Label htmlFor="code">Code</Label>
            <Input
              type="text"
              name="code"
              id="code"
              defaultValue={area.code}
            />
            {errors.code && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.code.join(', ')}
              </div>
            )}
          </div>

          <div className="my-2">
            <Label htmlFor="description">Description</Label>
            <Textarea

              name="description"
              id="description"
              defaultValue={area.description}
            />
            {errors.description && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.description.join(', ')}
              </div>
            )}
          </div>

          <div className="my-2">
            <Label htmlFor="status">Status</Label>
            <input type="hidden" name="status" value={status} />
            <Select value={status} onValueChange={setStatus}>
              <SelectTrigger id="status" className={"w-full"}>
                <SelectValue placeholder="Status" />
              </SelectTrigger>
              <SelectContent>
                {statusOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {errors.status && (
              <div className="text-red-500 px-3 py-2 font-medium">
                {errors.status.join(', ')}
              </div>
            )}
          </div>

          <div className="inline">
            <button
              type="submit"
              disabled={processing}
              className="rounded-lg py-3 px-5 bg-blue-600 text-white inline-block font-medium cursor-pointer"
            >
              {submitText}
            </button>
          </div>
        </>
      )}
    </InertiaForm>
  )
}
